export enum IModelLevel { 
	// The order of the items is crucial as it indicates the level of the model.
	PPS="pps",
	SPSXPPS="spsXPps",
	SPS="sps",
	REQUESTEDPROCEDURE="requestedProcedure",
	ORDER="orders",
	VISIT="visit",
	PATIENT="patient"
}